<template>
    <room-video
        v-bind="{
            stream,
            enabled_audio,
            enabled_video,
        }"
    />
</template>

<script>
import { mapGetters, mapState } from "vuex";

import RoomVideo from "./room-video.vue";

export default {
    components: {
        RoomVideo,
    },
    computed: {
        ...mapState("interview/client", ["enabled_audio", "enabled_video"]),
        ...mapGetters("interview/client", {
            stream: "stream_canvas",
        }),
    },
};
</script>

<style>
</style>